import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { ActivityIndicator } from 'react-native';
import Animated, { FadeIn } from 'react-native-reanimated';
import { styles } from './SavingButton.styles';
import { Gradients } from 'src/theme-v2/colors';
import { ProjectSaveButtonProps } from '../ProjectSaveButton.types';

export const SavingButton = ({ i18n, text }: ProjectSaveButtonProps) => {
  return (
    <Animated.View entering={FadeIn.duration(600)} style={styles.savingContentContainer}>
      <TextLato style={styles.savingContentText}>{i18n.t(text)}</TextLato>
      <ActivityIndicator size={20} color={Gradients.AngularGradient[0]} />
    </Animated.View>
  );
};
